import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { removeMember, leaveGroup } from '../../services/groupService';

const GroupMembersList = ({ group, members, subscription, onUpdate }) => {
  const { user } = useAuth();
  const isOwner = group?.owner_id === user?.id;
  const maxMembers = subscription?.max_members ?? 5;
  const memberCount = members.length;

  const handleRemove = async (userId, name) => {
    if (!window.confirm(`Remove ${name} from the cookbook?`)) return;
    try {
      await removeMember(userId);
      onUpdate();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to remove member');
    }
  };

  const handleLeave = async () => {
    if (!window.confirm('Are you sure you want to leave this cookbook?')) return;
    try {
      await leaveGroup();
      window.location.reload();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to leave cookbook');
    }
  };

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <h2 style={styles.title}>🍽️ {group.name}</h2>
        <span style={styles.badge}>
          {memberCount}/{maxMembers} members
        </span>
      </div>

      <ul style={styles.memberList}>
        {members.map((m) => (
          <li key={m.id} style={styles.memberItem}>
            <span>
              {m.name} {m.role === 'owner' && <span style={styles.ownerTag}>Owner</span>}
              {m.id === user.id && <span style={styles.youTag}>You</span>}
            </span>
            {isOwner && m.role !== 'owner' && (
              <button onClick={() => handleRemove(m.id, m.name)} style={styles.removeBtn}>
                Remove
              </button>
            )}
          </li>
        ))}
      </ul>

      {!isOwner && (
        <button onClick={handleLeave} style={styles.leaveBtn}>
          Leave Cookbook
        </button>
      )}
    </div>
  );
};

const styles = {
  card: {
    backgroundColor: 'white',
    padding: '32px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    marginBottom: '24px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    flexWrap: 'wrap',
    gap: '10px',
  },
  title: {
    color: '#e67e22',
    fontSize: '22px',
    margin: 0,
  },
  badge: {
    backgroundColor: '#fdf0e3',
    color: '#e67e22',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '600',
  },
  memberList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  memberItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 0',
    borderBottom: '1px solid #f0f0f0',
    color: '#444',
  },
  ownerTag: {
    marginLeft: '8px',
    fontSize: '11px',
    color: '#e67e22',
    fontWeight: '600',
  },
  youTag: {
    marginLeft: '8px',
    fontSize: '11px',
    color: '#999',
  },
  removeBtn: {
    padding: '4px 10px',
    backgroundColor: 'transparent',
    color: '#e74c3c',
    border: '1px solid #e74c3c',
    borderRadius: '6px',
    fontSize: '12px',
    cursor: 'pointer',
  },
  leaveBtn: {
    marginTop: '16px',
    padding: '10px 20px',
    backgroundColor: 'transparent',
    color: '#e74c3c',
    border: '1px solid #e74c3c',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};

export default GroupMembersList;
